// src/pages/About/About.jsx - Merged About Component
import React from "react";
import Layout from "../../components/Layout/Layout";
import "./About.css";

// Photos live in public/team/ — set img to null to show initials instead
const teamMembers = [
  { name: "Mariam Ojikutu", role: "Founder", img: "/team/mariam-ojikutu.jpg" },
  { name: "Ibrahim Ajumoko", role: "Co-founder", img: null },
];

const initials = (name) =>
  name
    .split(" ")
    .map((part) => part[0])
    .join("")
    .slice(0, 2);

const milestones = [
  { year: "2025", event: "Project inception" },
  { year: "2026", event: "Beta launch for students" },
  { year: "2027", event: "Full platform release" },
];

const About = () => {
  return (
    <Layout>
      <div className="about-page">
        {/* Hero Section */}
        <section className="about-hero">
          <div className="hero-content">
            <h1>About MyEduGenius</h1>
            <p>Revolutionizing education through artificial intelligence</p>
          </div>
        </section>

        {/* Mission Section */}
        <section className="about-mission">
          <div className="container">
            <div className="mission-content">
              <div className="mission-text">
                <h2>Our Mission</h2>
                <p>
                  MyEduGenius leverages AI to create a smarter, personalized learning 
                  experience for students and powerful teaching support for educators. 
                  We aim to make learning engaging, accessible, and effective for everyone.
                </p>
                <div className="mission-features">
                  <div className="feature">
                    <h4>🎯 Personalized Learning</h4>
                    <p>AI-driven content tailored to each student's needs</p>
                  </div>
                  <div className="feature">
                    <h4>🚀 Smart Teaching Tools</h4>
                    <p>Empowering educators with intelligent resources</p>
                  </div>
                  <div className="feature">
                    <h4>📊 Data-Driven Insights</h4>
                    <p>Analytics to track progress and optimize learning</p>
                  </div>
                </div>
              </div>
              <div className="mission-image">
                <img src="AI illustration.png" alt="AI Education Illustration" />
              </div>
            </div>
          </div>
        </section>

        {/* Team Section */}
        <section className="team-section">
          <div className="container">
            <h2>Meet the Team</h2>
            <div className="team-grid">
              {teamMembers.map((member, idx) => (
                <div key={idx} className="team-card">
                  <div className="team-image">
                    {member.img ? (
                      <img className="team-photo" src={member.img} alt={member.name} />
                    ) : (
                      <span className="team-avatar" aria-hidden="true">
                        {initials(member.name)}
                      </span>
                    )}
                  </div>
                  <div className="team-info">
                    <h4>{member.name}</h4>
                    <p>{member.role}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Timeline Section */}
        <section className="timeline-section">
          <div className="container">
            <h2>Our Impact</h2>
            <p className="section-subtitle">Milestones in our journey</p>
            <div className="timeline-grid">
              {milestones.map((milestone, idx) => (
                <div key={idx} className="timeline-card">
                  <div className="timeline-year">
                    <h3>{milestone.year}</h3>
                  </div>
                  <div className="timeline-content">
                    <p>{milestone.event}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Call to Action Section */}
        <section className="about-cta">
          <div className="container">
            <div className="cta-content">
              <h2>Ready to Transform Your Learning Experience?</h2>
              <p>Join thousands of students and educators already using MyEduGenius</p>
              <div className="cta-buttons">
                <button className="btn-primary">Get Started</button>
                <button className="btn-secondary">Learn More</button>
              </div>
            </div>
          </div>
        </section>
      </div>
    </Layout>
  );
};

export default About;